<div class="wide">
  <p-card class="custom-card admin-panel-user-preview-table overflow-hidden">
    <div class="table-section-title mb-6">Historia logowań</div>

    <p-table
      #table
      (onPage)="onPrimePageChange($event)"
      (onSort)="onPrimeSortChange($event)"
      [customSort]="true"
      [lazy]="true"
      [loading]="isDataLoading()"
      [paginator]="true"
      [paginatorStyleClass]="'customPrimePaginator'"
      [rowsPerPageOptions]="[5, 10, 25]"
      [rows]="tablePage()?.size || 5"
      [tableStyle]="{ 'min-width': '40rem' }"
      [totalRecords]="tablePage()?.totalElements || 0"
      [value]="rows()"
      class="customPrimeTable"
      paginatorDropdownAppendTo="body"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="loginAt">
            <div class="flex items-center gap-2">
              Data ostatniego logowania
              <p-sortIcon field="loginAt" />
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2">Sposób uwierzytelnienia</div>
          </th>
        </tr>
        <tr>
          <td class="table-filter-cell">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'loginAt')"
              (onSelect)="onPrimeFilterChange($event, 'loginAt')"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
              [(ngModel)]="tableFilters.loginAt"
              [showIcon]="true"
              [iconDisplay]="'input'"
              ariaLabel="Filtruj po dacie ostatniego logowania"
            />
          </td>
          <td class="table-filter-cell">
            <p-select
              ariaLabel="Filtruj po sposobie uwierzytelnienia"
              (onChange)="
                onPrimeFilterChange($event.value, 'authenticationMethod')
              "
              [options]="authenticationMethodOptions"
              [showClear]="true"
              [(ngModel)]="tableFilters.authenticationMethod"
              optionLabel="label"
              placeholder="Wybierz wartość"
              optionValue="value"
              appendTo="body"
              class="w-full"
            ></p-select>
          </td>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.loginAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
          <td>
            {{
              row.authenticationMethod
                | constLabelReader: AUTHENTICATION_METHOD_LABELS
            }}
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="2">Brak danych.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>

<div class="narrow">
  <p-card class="custom-card overflow-hidden">
    <div class="table-section-title mb-6">Historia logowań</div>

    <p-card class="mb-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <span class="font-bold" id="loginAtMobileLabel">
            Data ostatniego logowania
          </span>
          <p-date-picker
            ariaLabelledBy="loginAtMobileLabel"
            (onClear)="onPrimeFilterChangeMobile($event, 'loginAt')"
            (onSelect)="onPrimeFilterChangeMobile($event, 'loginAt')"
            [readonlyInput]="true"
            [showClear]="true"
            appendTo="body"
            class="w-full customDatePicker"
            dateFormat="dd-mm-yy"
            [(ngModel)]="tableFilters.loginAt"
          />
        </div>
        <div class="flex flex-col gap-2">
          <span class="font-bold" id="authenticationMethodMobileLabel">
            Sposób uwierzytelnienia
          </span>
          <p-select
            ariaLabelledBy="authenticationMethodMobileLabel"
            (onChange)="
              onPrimeFilterChangeMobile($event.value, 'authenticationMethod')
            "
            [options]="authenticationMethodOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.authenticationMethod"
            optionLabel="label"
            placeholder="Wybierz wartość"
            optionValue="value"
            appendTo="body"
            class="w-full"
          ></p-select>
        </div>
        <div class="flex justify-end">
          <p-button
            type="button"
            label="Wyczyść filtry"
            styleClass="customInfoButton outlined"
            (click)="clearFilters()"
          />
        </div>
      </div>
    </p-card>

    <div class="flex flex-col gap-4">
      @for (row of rows(); track row.id) {
        <p-card>
          <div class="flex flex-col">
            <app-preview-data-wrapper
              label="Data ostatniego logowania"
              [data]="row.loginAt | date: 'yyyy-MM-dd HH:mm:ss'"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Sposób uwierzytelnienia"
              [data]="
                row.authenticationMethod
                  | constLabelReader: AUTHENTICATION_METHOD_LABELS
              "
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
          </div>
        </p-card>
      } @empty {
        <p-card>
          <span>-</span>
        </p-card>
      }
    </div>

    <div class="mt-4 flex flex-col items-end gap-2">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[5, 10, 25]"
        [rows]="tablePage()?.size || 5"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
        appendTo="body"
      />
      <div class="text-sm">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>
  </p-card>
</div>
